import { Modal } from 'antd';
import './LayerProperties.scss';

interface IconSelectorModalProps {
  icons: {
    id: number;
    name: string;
    s3Key: string;
    url: string;
  }[];
  open: boolean;
  onClose: () => void;
  onSelect: (iconUrl: string) => void;
  selectedIconKey?: string;
}

export const IconSelectorModal = ({ icons, open, onClose, onSelect, selectedIconKey }: IconSelectorModalProps) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title="Choose Icon Style"
      // Sits above the per-category symbology editor modal (which opens from
      // the Unique tab) so "Choose from styles" never renders behind it.
      zIndex={2000}
    >
      <div className="lp-icon-modal__grid">
        {icons.map((icon) => {
          const isSelected = icon.s3Key === selectedIconKey;

          return (
            <div
              key={icon.id}
              className={['lp-icon-modal__item', isSelected ? 'lp-icon-modal__item--selected' : ''].filter(Boolean).join(' ')}
              onClick={() => {
                onSelect(icon.s3Key);
                onClose();
              }}
            >
              <img src={icon.url} alt={icon.name} className="lp-icon-modal__img" />
            </div>
          );
        })}
      </div>
    </Modal>
  );
};
